export default (path: string) => (!path ? '/assets/noname.png' : `${import.meta.env.VITE_API_URL}${path}`);
